import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay,FreeMode } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

import Partenaire1 from '../assets/partenaire1.jpg'
import Partenaire2 from '../assets/partenaire2.jpg'
import Partenaire3 from '../assets/partenaire3.jpg'
import Partenaire4 from '../assets/partenaire4.jpg'
import Partenaire5 from '../assets/partenaire5.jpg'
import Partenaire6 from '../assets/partenaire6.jpg'
import Partenaire7 from '../assets/partenaire7.jpg'


const Partenaire = () => {
  return (
    <section className='my-5 realisation-styling'>
      <main className='container d-flex flex-column justify-content-center align-items-center'>
        <h2 className='text-center mb-3'>Nos Partenaire</h2>
      </main>
      <Swiper
        slidesPerView={4}
        spaceBetween={30}
        loop={true}
        modules={[Autoplay,FreeMode]}
        autoplay={{delay:500}}
        freeMode={true}
        className="mySwiper mt-4 partenaire-swiper"
      >
        <SwiperSlide className='d-flex justify-content-center align-items-center'>
          <div className='d-flex justify-content-center align-items-center rounded partenaire-icon'>
                <img src={Partenaire1} className="img-fluid"/>
            </div>
        </SwiperSlide>
        <SwiperSlide className='d-flex justify-content-center align-items-center'>
          <div className='d-flex justify-content-center align-items-center rounded partenaire-icon'>
                <img src={Partenaire2} className="img-fluid"/>
            </div>
        </SwiperSlide>
        <SwiperSlide className='d-flex justify-content-center align-items-center'>
            <div className='d-flex justify-content-center align-items-center rounded partenaire-icon'>
              <img src={Partenaire3} className="img-fluid"/>
            </div>
        </SwiperSlide>
        <SwiperSlide className='d-flex justify-content-center align-items-center'>
        <div className='d-flex justify-content-center align-items-center rounded partenaire-icon'>
          <img src={Partenaire4} className="img-fluid"/>
        </div>
        </SwiperSlide>
        <SwiperSlide className='d-flex justify-content-center align-items-center'>
        <div className='d-flex justify-content-center align-items-center rounded partenaire-icon'>
          <img src={Partenaire5} className="img-fluid"/>
        </div>
        </SwiperSlide>
        <SwiperSlide className='d-flex justify-content-center align-items-center'>
        <div className='d-flex justify-content-center align-items-center rounded partenaire-icon'>
          <img src={Partenaire6} className="img-fluid"/>
        </div>
        </SwiperSlide>
        <SwiperSlide className='d-flex justify-content-center align-items-center'>
        <div className='d-flex justify-content-center align-items-center rounded partenaire-icon'>
          <img src={Partenaire7} className="img-fluid"/>
        </div>
        </SwiperSlide>
        
      </Swiper>
    </section>
    )
}

export default Partenaire